(function () {
  try {
    var path = window.location.pathname || '';
    if (path.indexOf('/pages/menu') === -1) return;

    var params = new URLSearchParams(window.location.search);
    // Old share links used ?view=picks, which Shopify maps to Market Conditions.
    if (params.get('view') === 'picks' && params.get('picks')) {
      params.delete('view');
      params.set('s67_view', 'picks');
      window.location.replace(path + '?' + params.toString());
      return;
    }

    function buildFixedShareUrl() {
      var url = new URL(window.location.origin + path);
      var root = document.querySelector('[data-storage-key="star67-menu-picks"]') || document.querySelector('.s67');
      var ids = [];
      if (root) {
        var selected = [];
        try {
          var stored = JSON.parse(localStorage.getItem('star67-menu-picks') || '[]');
          if (Array.isArray(stored)) selected = stored;
          else if (stored && Array.isArray(stored.ids)) selected = stored.ids;
        } catch (e) {}
        var buttons = root.querySelectorAll('[data-dish][data-id]');
        buttons.forEach(function (btn) {
          var id = btn.getAttribute('data-id');
          if (selected.indexOf(id) !== -1) ids.push(id);
        });
      }
      if (ids.length) url.searchParams.set('picks', ids.join(','));
      url.searchParams.set('s67_view', 'picks');
      return url.toString();
    }

    function fixShareFields() {
      document.querySelectorAll('[data-share-url]').forEach(function (input) {
        input.value = buildFixedShareUrl();
      });
    }

    document.addEventListener('click', function (e) {
      var copyBtn = e.target.closest('[data-copy-share]');
      var nativeBtn = e.target.closest('[data-native-share]');
      var emailBtn = e.target.closest('[data-email-guests]');
      if (!copyBtn && !nativeBtn && !emailBtn) return;

      var link = buildFixedShareUrl();
      var input = document.querySelector('[data-share-url]');
      if (input) input.value = link;

      if (copyBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(link).catch(function () {});
        } else if (input) {
          input.focus();
          input.select();
        }
      }

      if (nativeBtn && navigator.share) {
        e.preventDefault();
        e.stopPropagation();
        navigator.share({
          title: 'Star 67 menu picks',
          text: 'Here are our Star 67 picks — open the link to review and add your own.',
          url: link
        }).catch(function () {});
      }

      if (emailBtn) {
        // Let existing handler run, but rewrite mailto after a tick if needed.
        setTimeout(function () {
          /* no-op: copy/native covered; email handler builds its own link from buildShareUrl in page JS */
        }, 0);
      }
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixShareFields);
    } else {
      fixShareFields();
    }
    setInterval(fixShareFields, 1500);
  } catch (err) {}
})();
